import { createSvgIcon } from '@mui/material';

export const Sparkles = createSvgIcon(
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.16667 1.5V4.83333V1.5ZM1.5 3.16667H4.83333H1.5ZM4 13.1667V16.5V13.1667ZM2.33333 14.8333H5.66667H2.33333ZM9.83333 1.5L11.7383 7.21417L16.5 9L11.7383 10.7858L9.83333 16.5L7.92833 10.7858L3.16667 9L7.92833 7.21417L9.83333 1.5Z" stroke="#6B7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
  'Sparkles',
);
